import $ from 'jquery';

const Captcha = {
    init() {
        const $captcha = $('.js-recaptcha');

        if (!$captcha.length) return;

        $captcha.find('button').prop('disabled', true).addClass('disabled');

        // This reCaptcha script does not handle multiple forms on the same page
        this.handleCaptcha();
    },

    handleCaptcha() {
        const $captcha = $('.js-recaptcha');

        window.grecaptcha.ready(() => {
            window.grecaptcha.execute(process.env.MIX_G_CAPTCHA_PUBLIC).then((token) => {
                $captcha.append(`<input type="hidden" name="g-recaptcha-response" value="${token}">`);
                $captcha.find('button').prop('disabled', false).removeClass('disabled');
            });
        });
    },
};

export default Captcha;
